import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import invariant from 'invariant';
import ControlledTabs from './controlled';

function usePersistedState(key, defaultValue) {
  var lsKey = "tabs/".concat(key);
  var ls = window.localStorage.getItem(lsKey);
  var initialValue = ls ? JSON.parse(ls).value || defaultValue : defaultValue;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    window.localStorage.setItem(lsKey, _JSON$stringify({
      value: state
    }));
  }, [lsKey, state]);
  return [state, setState];
}

export function PersistedTabs(_ref) {
  var _items$;

  var id = _ref.id,
      items = _ref.items,
      rest = _objectWithoutProperties(_ref, ["id", "items"]);

  invariant(id, "You have to define an ID to persist the tabs state in local storage!");

  var _usePersistedState = usePersistedState("".concat(id, "/active"), items === null || items === void 0 ? void 0 : (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.name),
      _usePersistedState2 = _slicedToArray(_usePersistedState, 2),
      activeTab = _usePersistedState2[0],
      setActiveTab = _usePersistedState2[1];

  useEffect(function () {
    if (!_findInstanceProperty(items).call(items, function (item) {
      return item.name === activeTab;
    })) {
      var _items$2;

      setActiveTab(items === null || items === void 0 ? void 0 : (_items$2 = items[0]) === null || _items$2 === void 0 ? void 0 : _items$2.name);
    }
  }, [activeTab, items, setActiveTab]);

  function handleChange(_ref2) {
    var name = _ref2.name;
    setActiveTab(name);
  }

  return /*#__PURE__*/React.createElement(ControlledTabs, _extends({
    items: items
  }, rest, {
    activeTab: activeTab,
    onChange: handleChange
  }));
}
export default PersistedTabs;